module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rain2-23f9bea9ee6123e0e9dcbd2af1a99393.svg";